import {useTranslation} from 'react-i18next';
import HeaderWithIcons from '@components/app/HeaderWithIcons';

export default function BarandeBash() {
	const {t} = useTranslation();
	return (
		<div className="w-full h-full flex flex-col">
			<HeaderWithIcons backUrl="/" title={t('barandebash')}/>
			<iframe className="h-full" src="https://www.razavi.ir/fa/barandebash"/>
		</div>
	);
}
